import { FETCH_ACTIVITY_STATUSES_SUCCEEDED } from './activityStatus.action';
import { pathOr } from 'ramda';

export const activityStatusReducer = (state = [], action) => {
	switch (action.type) {
		case FETCH_ACTIVITY_STATUSES_SUCCEEDED: {
			return pathOr([], ['payload', 'data'], action);
		}

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/redux/activityStatuses/activityStatus.reducer.js